/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from "react";
import { PropTypes } from "prop-types";
import MyEditor from "../../MyEditor";


const TopicComponent = ({
  activeLanguage,
  languages,
  topic,
  collapsibleFAQsGetsTopic,
  indexId,
  handleRemoveTopic,
  arrLength
}) => {
  const initialState = {
    title: { es: "", en: "", ca: "" },
    paragraph: { es: "", en: "", ca: "" }
  };

  const [state, setState] = useState(initialState);
  const [canBeDeleted, setDeletionMark] = useState(false);

  useEffect(() => {
    setState(topic);
  }, []);

  useEffect(() => {
    if (arrLength - 1 === indexId) {
      setDeletionMark(true);
    } else {
      setDeletionMark(false);
    }
  }, [arrLength]);

  const inputHandler = (value, name, lang) => {
    const comp = {
      ...state,
      [name]: {
        ...state[name],
        [lang.toLowerCase()]: value
      }
    };

    setState(comp);

    collapsibleFAQsGetsTopic(comp, indexId);
  };
  const handleTitle = e => {
    const { value, name, lang } = e.target;
    inputHandler(value, name, lang);
  };

  const handleInput = (contentHtml, lang) => {
    inputHandler(contentHtml, "paragraph", lang);
  };

  return (
    <>
      {languages.map(lang => (
        <div
          key={lang}
          className={`${
            activeLanguage.toLowerCase() === lang.toLowerCase()
              ? "block"
              : "hidden"
          } w-full px-4 pb-1 pt-2 bg-greyFilter rounded-lg`}
        >
          <div className="w-full bg-greyFilter px-10 border-t-1 border-dashed border-black pt-1">
            <div className="flex justify-between items-center">
              <label
                className="flex flex-col font-americaMonoRegular text-xs uppercase text-black w-full"
                htmlFor="subTitle"
              >
                Title
                <input
                  className="mt-2 font-americaMonoRegular p-2 bg-white outline-none w-full rounded-full"
                  onChange={handleTitle}
                  name="title"
                  lang={lang}
                  type="text"
                  value={state.title && state.title[lang.toLowerCase()]}
                />
              </label>
              {canBeDeleted && (
                <div className="self-start -mr-8">
                  <span
                    onClick={() => handleRemoveTopic(indexId)}
                    className="font-icon icon-close-solid text-16 text-black cursor-pointer"
                  />
                </div>
              )}
            </div>
            <label
              className=" relative mt-6px flex flex-col font-americaMonoRegular text-xs  text-black "
              htmlFor="paragraphText"
            >
              <span className="uppercase">Paragraph</span>
              {/* <input className="mt-2 font-americaMonoRegular p-2 bg-white outline-none w-full rounded-full" onChange={inputHandler} name="paragraph" lang={lang} type="text" value={state.paragraph && state.paragraph[lang.toLowerCase()]} /> */}
              <div className="text-black font-americaMonoRegular p-2 overflow-auto text-xs leading-normal mt-2 bg-white rounded-lg">
                <MyEditor
                  retrieveInput={handleInput}
                  lang={lang}
                  value={state.paragraph[lang.toLowerCase()]}
                  classes="px-8 pb-4"
                />
              </div>
            </label>
          </div>
        </div>
      ))}
    </>
  );
};

TopicComponent.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleRemoveTopic: PropTypes.func.isRequired,
  topic: PropTypes.shape().isRequired,
  indexId: PropTypes.number.isRequired,
  arrLength: PropTypes.number.isRequired,
  collapsibleFAQsGetsTopic: PropTypes.func.isRequired
};
TopicComponent.defaultProps = {};

export default TopicComponent;
